import {Transition, TransitionChild} from "@headlessui/react";

export const Modal = ({children, isOpen, zIndex = "z-[100]"}) => {
	return (
		<Transition show={isOpen}>
			{/* Backdrop */}
			{/* h-[100%] w-[100%] */}
			<div
				className={`fixed inset-0 ${zIndex}
                    flex items-center justify-center
                    h-full w-full
                    bg-black/75 backdrop-blur-sm
                    data-[closed]:opacity-0
                    data-[enter]:duration-75 data-[enter]:data-[closed]:ease-out
                    data-[leave]:duration-300 data-[leave]:data-[closed]:ease-out`}
			>
				{/* Modal Panel */}
				<TransitionChild>
					<div
						className={`${zIndex} h-full w-full flex items-center justify-center
                            md:h-auto md:max-h-[min(90%,800px)]
                            md:w-auto md:min-w-[min(40%,480px)] md:max-w-[min(90%,1200px)]
                            overflow-y-auto overscroll-contain
                            md:rounded-xl
                            data-[enter]:duration-100 data-[enter]:data-[closed]:scale-50
                            data-[leave]:duration-300 data-[leave]:data-[closed]:scale-95`}
					>
						{children}
					</div>
				</TransitionChild>
			</div>
		</Transition>
	);
};